import Profile from '../components/Settings/Settings.vue'

let routes = {
    path: '/settings',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/settings',
            name: 'Configurações',
            component: Profile,
            meta: {
              title: "Configurações",
            }
        }
    ]
}


export default routes



// WEBPACK FOOTER //
// ./src/router/settings.js